import locales from './lang';
import Massages from './messages';
export default class I18n {
    static messages = {};
    static _set(lang, rawMessages) {
        this.messages[lang] = rawMessages;
    }
    static _get(lang) {
        this._load(lang);
        return this.messages[lang];
    }
    static _setRuleMessage(lang, attribute, message) {
        this._load(lang);
        const messages = Object.create(this.messages);
        if (message === undefined) {
            message = messages[lang].def;
        }
        messages[lang][attribute] = message;
    }
    static _load(lang) {
        if (!this.messages[lang])
            this._set(lang, locales[lang]);
    }
    static _make(lang) {
        const messages = Object.create(this.messages);
        this._load(lang);
        return new Massages(messages[lang]);
    }
}
